import React, {useState} from 'react'
import { ScrollView, View, StyleSheet, Image, Keyboard, Linking, Platform } from 'react-native'
import { SafeAreaView } from 'react-native-safe-area-context'
import { adaptive, backgroundColors, colors, typography } from '@sart/styles'
import { useContent } from '@sart/content'
import {
  Title,
  Description,
  Space,
  Button,
  Anchor
} from '@sart/components'
import client from '@sart/client'

import AppConfig from '../Configuration'
import { set } from 'lodash'

export default function ServiceSettings(props) {
  const { navigation } = props
  const [loading, setLoading] = useState(false)

  const content = useContent()

  async function submitPortOut(type) {
      Keyboard.dismiss()
      setLoading(true)
      
      console.log('Submitting port out request of type: ' + type)
  
      try {
        const portOutProducts = await client.callApi('catalog', 'getModifyServiceDetailsProducts', [client.cache.catalogId])
        console.log('Port out products', JSON.stringify(portOutProducts,null,2))
  
        const portOutProduct = portOutProducts.find(product => product.productLegacyId === AppConfig.portOutProduct)
        console.log('Port out product', portOutProduct)
  
        if (!portOutProduct) {
          throw new Error(content.switch_number.portInProduct)
        }
  
        const extendedData = {
          portType: type
        }

        console.log('Extended data for port out:', JSON.stringify(extendedData,null,2))
  
        //sumbit order
        const order = await client.checkoutServiceProduct(portOutProduct, extendedData)
  
        console.log('Order is:', JSON.stringify(order, null, 2))

        setLoading(false)
        
        if (order && order.status === 'successful') {
    
          const params = {
            confirmation: {
              title: type + ' Requested',
              description: 'Your ' + type + ' request has been sent and you should shortly receive your ' + type + ' via SMS'  //content.port.confirmationInstruction
            }
          }
          navigation.navigate('Confirmation', params)
  
        } else {
          console.log('Port out order failed:', JSON.stringify(order, null, 2))
          // setOrderError(content.port.orderFailed)
        }
  
      } catch (error) {
        console.log('error in port out ' + JSON.stringify(error,null,2))
        // const message = prettyErrorMessage(error)
  
        // form.setFieldError('gender', message)
      }

      setLoading(false)
    }

  return (
    <ScrollView style={styles.container} contentContainerStyle={styles.contentContainer}>
        <View style={styles.widthRestrictions}>
            <View style={styles.logo}>
                <Image
                    source={{ uri: 'https://shop.bikermobile.com/assets/biker_mobile_logo_final_nobg.png' }}
                    height={75} width={75}
                />
            </View>
            <Description style={styles.description}>
                {content.switch_number.portOutPACInstructions}
            </Description>
            <Space height={24} />
            <Button
              title='Request PAC'
              disabled={loading}
              onPress={() => submitPortOut('PAC')}
              style={styles.enabled}
              disabledStyle={styles.disabled}
              titleStyle={{ ...typography.extrabold, fontSize: 14, color: colors.white }}
              disabledTitleStyle={{...typography.extrabold, fontSize: 14, color: colors.white + 45}}  
              />
            <Space height={24} />
            <Description style={styles.description}>
                {content.switch_number.portOutSTACInstructions}
            </Description>
            <Space height={24} />
            <Button
              title='Request STAC'
              disabled={loading}
              onPress={() => submitPortOut('STAC')}
              style={styles.enabled}
              disabledStyle={styles.disabled}
              titleStyle={{ ...typography.extrabold, fontSize: 14, color: colors.white }}
              disabledTitleStyle={{...typography.extrabold, fontSize: 14, color: colors.white + 45}}  
              />
            <Space height={24} />
            <Description style={styles.description}>
                {content.switch_number.seeFAQs} <Anchor
                          style={styles.link}
                          title={content.switch_number.portOutFAQsLink}
                          onPress={() => Linking.openURL('https://bikermobile.com/faqs/')}
                        />
            </Description>
        </View>
    </ScrollView>
  )
}

const styles = StyleSheet.create({
  logo: {
    alignSelf: 'center'
  },
  container: {
    flex: 1,
    paddingTop: 24,
    paddingBottom: 0,
    backgroundColor: backgroundColors.darkCharcoal,
    ...adaptive.wrapperPadding,
  },
  contentContainer: {
    ...Platform.select({
      web: {
        alignItems: 'center'
      }
    })
  },
  title: {
    color: colors.brightOrange,
    ...typography.demi
  },
  description: {
    textAlign: 'center',
    color: colors.white,
    ...typography.demi,
    marginLeft: 15,
    marginRight: 15,
    fontSize: 12,
  },
  enabled: {
    backgroundColor: colors.brightOrange,
    width: '70%',
    height: 48,
    alignSelf: 'center'
  },
  disabled: {
    backgroundColor: colors.brightOrange + 60,
    width: '70%',
    height: 48,
    alignSelf: 'center'
  },
  link: {
    color: colors.brightOrange,
    textDecorationLine: 'underline',
    fontWeight: '600', // Slightly bold
    fontSize: 12
  },
  widthRestrictions: {
    width: '100%',
    maxWidth: 600,
    paddingBottom: 40
  }
})
